import React from "react";
import { Typography } from "@aph/ui-lib-humanx";
import { DeviceInfo } from "@/interface/deviceInfo";
import { BannerWithDescComponent } from "@/components/ToolsPage/api/interface";
import ImageComponent from "@/components/Image";
import styles from "./BannerWithDesc.module.scss";

interface BannerWithDescProps {
  data: BannerWithDescComponent;
  userAgent: DeviceInfo;
}

const BannerWithDesc: React.FC<BannerWithDescProps> = ({ data, userAgent }) => {
  const { Title, Description, Image } = data;

  return (
    <section className={styles.container}>
      <ImageComponent
        src={Image?.data?.attributes?.url}
        className={styles.bgImage}
        alt={Image?.data?.attributes?.alternativeText}
        eagerLoad={true}
      />
      {Title && (
        <Typography component="h1" className={`${styles.title}`}>
          <div dangerouslySetInnerHTML={{ __html: Title }}></div>
        </Typography>
      )}
      {Description && (
        <Typography component="h5" className={`${styles.subtitle}`}>
          {Description}
        </Typography>
      )}
    </section>
  );
};

export default BannerWithDesc;
